import { render, staticRenderFns } from "./ReviewUpLimitPromotion.vue?vue&type=template&id=06f1506e&scoped=true"
import script from "./ReviewUpLimitPromotion.vue?vue&type=script&lang=js"
export * from "./ReviewUpLimitPromotion.vue?vue&type=script&lang=js"
import style0 from "./ReviewUpLimitPromotion.vue?vue&type=style&index=0&id=06f1506e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1506e",
  null
  
)

export default component.exports